// Utilidades para nombrar y descargar fotos: Espacio_Marca_NN.jpg
export const slugFoto = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 _-]/g, "_")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .slice(0, 60)
    .replace(/^_+|_+$/g, "") || "foto";

export const nombreFotoBase = (espacio, marca) =>
  slugFoto(espacio) + (marca ? `_${slugFoto(marca)}` : "");

// Cloudinary: fl_attachment fuerza la descarga con el nombre indicado
export const fotoDownloadUrl = (url, nombre) => {
  if (!url) return url;
  if (url.includes("/upload/") && !url.includes("fl_attachment")) {
    return url.replace("/upload/", `/upload/fl_attachment:${nombre}/`);
  }
  return url;
};
